module.exports = __webpack_public_path__ + "img/banner.a3ee57ab.png";